import React from 'react'

import {Input} from 'forms'

export const Static = ({group, field, spec}) => (
   <div>
      <Input
         param={group + '.' + field}
         label={spec.label || group + '.' + field}
         disabled={true}
      />
   </div>
)

Static.propTypes = {
   group: React.PropTypes.string.isRequired,
   field: React.PropTypes.string.isRequired,
   spec:  React.PropTypes.object.isRequired,
   value: React.PropTypes.any
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/device/configuration/fields/Static.jsx